export type MileageScopedEditSection =
  | 'basicInformation'
  | 'tripInformation'
  | 'mileageInformation'
  | 'budgetAndProject'
  | 'costCenters'
  | 'additionalInformation'

const MILEAGE_SCOPED_EDIT_SECTIONS: ReadonlySet<string> = new Set<MileageScopedEditSection>([
  'basicInformation',
  'tripInformation',
  'mileageInformation',
  'budgetAndProject',
  'costCenters',
  'additionalInformation',
])

export const isMileageScopedEditSection = (section: string): section is MileageScopedEditSection =>
  MILEAGE_SCOPED_EDIT_SECTIONS.has(section)
